<template>
  <tr class="v-data-table__mobile-table-row">
    <slot name='prepend' />

    <td
      v-for='(header, index) of headers'
      :key='index'
      class='v-data-table__mobile-row'
    >
      <div class='v-data-table__mobile-row__header'>
        {{ header.text }}
      </div>
      <div class='v-data-table__mobile-row__cell'>
        {{ values[header.value] | emptyValueAsHyphen }}
      </div>
    </td>

    <slot name='append' />
  </tr>
</template>

<script>
export default {
  name: 'FixedSumRowMobile',
  props: {
    headers: { type: Array, required: true },
    values: { type: Object, default: () => ({}) }
  }
};
</script>
